/**
 * @description Select item
 * @author PravinKumar
 * @since April 17, 2019
 */

import NativeSelect from '@material-ui/core/NativeSelect'
import { withStyles } from '@material-ui/core/styles'
import moment from 'moment'

const styles = () => ({
  select: {
    fontWeight: '600',
    fontSize: '15px',
    width: 'auto',
    paddingRight: '21px',
    textAlignLast: 'center',
    textAlign: 'center',
  },
})
const MonthYearSelect = props => {
  const { month, onMonthSelect, onYearSelect, years, classes } = props
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div
        style={{
          position: 'relative',
          justifyContent: 'center',
        }}
      >
        <NativeSelect
          className="month-dropdown-selection"
          value={month.month()}
          disableUnderline
          classes={{ select: classes.select }}
          onChange={e => {
            onMonthSelect(month, e.target.value)
          }}
        >
          {moment.months().map((label, value) => (
            <option key={label} value={value}>
              {label}
            </option>
          ))}
        </NativeSelect>
      </div>
      <div>
        <NativeSelect
          disableUnderline
          classes={{ select: classes.select }}
          className="month-dropdown-selection"
          value={month.year().toString()}
          onChange={e => {
            onYearSelect(month, e.target.value)
          }}
        >
          {years.map(year => (
            <option key={year} value={moment().format(year)}>
              {moment().format(year)}
            </option>
          ))}
        </NativeSelect>
      </div>
    </div>
  )
}

MonthYearSelect.defaultProps = {}
export default withStyles(styles)(MonthYearSelect)
